import BarLineChart from './src/barLineChart';
import { withInstall } from '../_util/type';
export default withInstall(BarLineChart);
